import { render } from "./BeneficiarioTarjetaComponent.vue?vue&type=template&id=82caf9a6&scoped=true"
import script from "./BeneficiarioTarjetaComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiarioTarjetaComponent.vue?vue&type=script&lang=js"

import "./BeneficiarioTarjetaComponent.vue?vue&type=style&index=0&id=82caf9a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82caf9a6"]])

export default __exports__